/**
 * Testimonial — Cormorant pull-quote, gold hairline above, Jost UPPERCASE
 * attribution below. One quote per section, no carousel, no cards, generous
 * space. Use a bracketed [TESTIMONIAL] placeholder where copy is not supplied.
 */
export const Testimonial = ({
  quote = "[ Testimonial — quote to be supplied. ]",
  name = "[ Name ]",
  descriptor = "[ Short descriptor ]",
  bg = "ivory", // 'ivory' | 'sand'
  testId,
}) => {
  const bgClass = bg === "sand" ? "bg-sand" : "bg-ivory";
  return (
    <section
      className={`${bgClass} border-t border-temple/10`}
      data-testid={testId || "testimonial"}
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 text-center">
        <hr className="hairline mx-auto w-16" />
        <blockquote
          className="mt-12 md:mt-16 font-serif font-light text-temple leading-[1.15] tracking-[0.005em]"
          style={{ fontSize: "clamp(1.6rem, 3.2vw, 2.6rem)" }}
          data-testid="testimonial-quote"
        >
          <span aria-hidden className="text-gold mr-1">“</span>
          {quote}
          <span aria-hidden className="text-gold ml-1">”</span>
        </blockquote>
        <p
          className="mt-10 font-sans font-light text-stone text-[0.72rem] tracking-[0.28em] uppercase"
          data-testid="testimonial-attribution"
        >
          {name} · {descriptor}
        </p>
      </div>
    </section>
  );
};

export default Testimonial;
